<ng-container>
    <navbar-vertical-style-2></navbar-vertical-style-2>
</ng-container>
